
import Vue from "vue";
export default Vue.extend({
	data() {
		return {
			open: true
		};
	},
	props: {
		value: Boolean
	},
	computed: {
		angleDirection():string {
			if (this.open) {
				return "angle-down";
			}
			return "angle-up";
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(newValue:boolean) {
				this.open = newValue;
			}
		}
	},
	methods: {
		onClick() {
			this.open = !this.open;
			this.$emit("input", this.open);
		},
	},
	created() {
		if (this.value != null) {
			this.open = this.value;
		}
	}
});
